import React, { FC, memo } from 'react';
import classes from './practiceCarousel.module.css';
import joy_boy from 'static/materials/joy_boy.png';

export const NinthView: FC = memo(() => {
  return (
    <>
      <div className={classes.blackBorder}>さあ、さっそく練習だ！</div>
      <div className={classes.joyboyWrapper}>
        <img src={joy_boy} alt=""></img>
      </div>
    </>
  );
});
